import React from 'react';

export const WZItemsList: React.FC<{
  children: React.ReactNode;
  compact?: boolean;
}> = ({ children, compact = false }) => (
  <div
    className={`wz-items-list${compact ? ' wz-items-list--compact' : ''}`}
    data-testid="wz-items-list"
  >
    {children}
  </div>
);

export const WZItemCard: React.FC<{
  index: number;
  positionLabel: React.ReactNode;
  product: React.ReactNode;
  productLabel: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
}> = ({ index, positionLabel, product, productLabel, children, action, compact = false }) => (
  <article className={`wz-item-card${compact ? ' wz-item-card--compact' : ''}`}>
    <header className="wz-item-card__header">
      <span className="wz-item-card__index" aria-label={`${index + 1}`}>{positionLabel}</span>
      <div className="wz-item-card__product">
        <span className="wz-item-field__label">{productLabel}</span>
        <div className="wz-item-card__product-control">{product}</div>
      </div>
      {action && <div className="wz-item-card__action">{action}</div>}
    </header>
    <div className="wz-item-card__fields">{children}</div>
  </article>
);

export const WZItemField: React.FC<{
  label: React.ReactNode;
  children?: React.ReactNode;
  wide?: boolean;
  emphasis?: boolean;
}> = ({ label, children, wide = false, emphasis = false }) => (
  <div
    className={[
      'wz-item-field',
      wide ? 'wz-item-field--wide' : '',
      emphasis ? 'wz-item-field--emphasis' : '',
    ].filter(Boolean).join(' ')}
  >
    <span className="wz-item-field__label">{label}</span>
    <div className="wz-item-field__value">{children == null || children === '' ? '—' : children}</div>
  </div>
);
